<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <rect ref="frame" id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <clipPath id="clip-frame">
        <use xlink:href="#Frame"/>
      </clipPath>
      <g ref="clip" clip-path="url(#clip-frame)">
        <g ref="main">
          <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
            <picture>
              <source :srcset="`${publicPath}scenes/horse-ride/HorseRide1-480w.jpg`" media="(max-width: 480px)">
              <source :srcset="`${publicPath}scenes/horse-ride/HorseRide1-768w.jpg`" media="(max-width: 768px)">
              <source :srcset="`${publicPath}scenes/horse-ride/HorseRide1-1280w.jpg`" media="(max-width: 1280px)">
              <source :srcset="`${publicPath}scenes/horse-ride/HorseRide1-1920w.jpg`" media="(max-width: 1920px)">
              <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/horse-ride/HorseRide1.jpg`" />
            </picture>
          </foreignObject>
          <g class="hair">
            <image width="1896" height="1595" x="63" y="1089" :xlink:href="`${publicPath}scenes/horse-ride/HorseRide2.png`"/>
            <image width="1910" height="1558" x="24" y="1085" :xlink:href="`${publicPath}scenes/horse-ride/HorseRide3.png`"/>
            <image width="1871" height="1599" x="42" y="1056" :xlink:href="`${publicPath}scenes/horse-ride/HorseRide4.png`"/>
            <image width="1863" height="1580" x="69" y="1064" :xlink:href="`${publicPath}scenes/horse-ride/HorseRide5.png`"/>
          </g>
        </g>
      </g>
    </svg>
    <SceneDialogue
      :ref="`dialogue`"
      :width=".33"
      :tx="0.94" :ty="0.2">
      Max went back to cattle-herding in Tsegi. He always found his way back
      to it. One time, John Ford came to the canyon to film his “cowboy-Indian
      movies.” Max let them borrow his herd for the films. Sometimes, when
      herding wasn’t enough to get by, Max and his brothers worked together on
      the railroad.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/horse-ride/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  mounted() {
    const main = this.$refs["main"]
    const d = this.$refs["dialogue"].$el
    TweenLite.set(main, {opacity: 0, scale: 1.2, x: "-0%", transformOrigin: "right center"})
    TweenLite.set(d, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(main, 1, {opacity: 1, scale: 1, x: "0%"}), 0.5)
    this.tl.add(TweenLite.to(d, 1, {opacity: 1}))
  },
  methods: {
    enter() {this.tl.play()}
  },
  props: ["slide"]
}
</script>

<style lang="scss" scoped>
.hair {
  image {
    animation: hair 0.8s infinite;
    animation-timing-function: steps(0, end);
    &:nth-of-type(1) { animation-delay: 0s; }
    &:nth-of-type(2) { animation-delay: -.2s; }
    &:nth-of-type(3) { animation-delay: -.4s; }
    &:nth-of-type(4) { animation-delay: -.6s; }
  }
}

@keyframes hair {
  0% { opacity: 1 }
  25% { opacity: 0 }
  50% { opacity: 0 }
}
</style>
